export const colors = {
  // primary: {
  //   // (BACKGROUND & TINT)
  //   50: { value: "#ECECFF" }, // Dùng làm nền cho App (Page Background) hoặc nền khi hover vào một hàng trong bảng danh sách (Table Row Hover).
  //   100: { value: "#D4D5FF" }, // Dùng làm nền cho các thẻ Tag/Chip (ví dụ: background của tag "Mới tốt nghiệp"), hoặc nền của Sidebar mục đang chọn (Selected Item).

  //   // (DECORATIVE & BORDERS)
  //   200: { value: "#A9AAFF" }, // Dùng cho đường viền (Border) của các Card quan trọng muốn nhấn mạnh, hoặc đường kẻ phân cách trong Dark Mode.
  //   300: { value: "#7E80FF" }, // Dùng cho trạng thái Disable (Nút bấm khi chưa điền đủ thông tin), hoặc viền Focus (khi tab vào input).

  //   // (SECONDARY)
  //   400: { value: "#6265FF" }, // Dùng cho các Icon phụ, hoặc các biểu đồ (Chart) cột thứ 2 để so sánh dữ liệu.

  //   // (BRANDING CORE)
  //   500: { value: "#5B60FD" }, // BASE COLOR: Màu thương hiệu chính. Dùng cho Primary Button (Nút "Tạo tin tuyển dụng"), Checkbox đã chọn, Toggle Switch ON.
  //   600: { value: "#494DEE" }, // HOVER STATE: Màu khi di chuột vào nút 500. Tạo cảm giác tương tác phản hồi.

  //   // (EMPHASIS & INTERACTION)
  //   700: { value: "#3B3FBE" }, // PRESSED STATE: Màu khi nhấn giữ chuột vào nút. Cũng dùng cho các Text Link (đường dẫn) để đảm bảo độ tương phản cao trên nền trắng.
  //   800: { value: "#2C2E8E" }, // Dùng cho các Icon chính trong thanh điều hướng (Navigation), hoặc viền đậm của các Input khi đang Active.

  //   // (TEXT & STRUCTURE)
  //   900: { value: "#1D1E5F" }, // Dùng thay màu Đen (#000000). Sử dụng cho Tiêu đề lớn (H1, H2), hoặc làm nền tối (Dark Background) cho thanh Sidebar bên trái.
  // },

  primary: {
    // (BACKGROUND & TINT)
    50: { value: "#F3EEFF" },
    100: { value: "#E0D5FF" },

    // (DECORATIVE & BORDERS)
    200: { value: "#C2AFFF" },
    300: { value: "#A389FF" },

    // (SECONDARY)
    400: { value: "#7A5CFF" },

    // (BRANDING CORE)
    500: { value: "#5B21F4" }, // base
    600: { value: "#4C1DD1" }, // hover

    // (EMPHASIS & INTERACTION)
    700: { value: "#3D17A8" },
    800: { value: "#2E127E" },

    // (TEXT & STRUCTURE)
    900: { value: "#1F0C54" },
  },

  neutral: {
    50: { value: "#f8fafc" }, // Background nền tổng (App Background)
    100: { value: "#f1f5f9" }, // Background phụ (Sidebar, Header nền nhạt)
    200: { value: "#e2e8f0" }, // Đường kẻ (Divider), Viền bảng (Border)
    300: { value: "#cbd5e1" }, // Viền input, Icon disable
    400: { value: "#94a3b8" }, // Icon phụ, Text placeholder
    500: { value: "#64748b" }, // Text phụ (caption, timestamp)
    600: { value: "#475569" }, // Text body (đoạn văn mô tả dài)
    700: { value: "#334155" }, // Text tiêu đề phụ (H3, H4)
    800: { value: "#1e293b" }, // Text tiêu đề chính (H1, H2)
    900: { value: "#0f172a" }, // Thay thế màu đen tuyệt đối
  },
  // neutral: {
  //   50: { value: "#FAF8F5" }, // nền chính, hơi ngả giấy
  //   100: { value: "#F3F0EB" }, // sidebar / section nhẹ
  //   200: { value: "#E4DED6" }, // border mềm, không gắt
  //   300: { value: "#D2C9BE" }, // input border / divider nhẹ
  //   400: { value: "#A89F94" }, // placeholder / icon phụ
  //   500: { value: "#7C746A" }, // text phụ
  //   600: { value: "#5C554D" }, // body text (đọc lâu rất ổn)
  //   700: { value: "#474039" }, // heading nhỏ
  //   800: { value: "#2F2A25" }, // heading chính
  //   900: { value: "#1C1916" }, // gần đen nhưng ấm
  // },

  dark: {
    50: { value: "#E2E8F0" },
    100: { value: "#CBD5E1" },
    200: { value: "#94A3B8" },
    300: { value: "#64748B" },
    400: { value: "#475569" },
    500: { value: "#334155" },
    600: { value: "#1E293B" },
    700: { value: "#1A2333" },
    800: { value: "#151B26" },
    900: { value: "#0B0F19" },
  },
  gray: {
    50: { value: "#F9FAFB" },
    100: { value: "#F3F4F6" },
    200: { value: "#E5E7EB" },
    300: { value: "#D1D5DB" },
    400: { value: "#9CA3AF" },
    500: { value: "#6B7280" },
    600: { value: "#4B5563" },
    700: { value: "#374151" },
    800: { value: "#1F2937" },
    900: { value: "#111827" },
  },
  terracotta: {
    50: { value: "#fdf1ee" },
    100: { value: "#f8d9d0" },
    200: { value: "#f2b4a8" },
    300: { value: "#ec8f80" },
    400: { value: "#e87165" },
    500: { value: "#e76f51" },
    600: { value: "#ce5b43" },
    700: { value: "#b34e3a" },
    800: { value: "#994230" },
    900: { value: "#7a3425" },
  },
  "desert-gold": {
    50: { value: "#fefae8" },
    100: { value: "#fcf0c4" },
    200: { value: "#f9e38d" },
    300: { value: "#f4d45c" },
    400: { value: "#efc737" },
    500: { value: "#e9c46a" },
    600: { value: "#d0aa50" },
    700: { value: "#b18d3d" },
    800: { value: "#93702f" },
    900: { value: "#785923" },
  },
  red: {
    50: { value: "#fef2f2" },
    100: { value: "#fee2e2" },
    200: { value: "#fecaca" },
    300: { value: "#fca5a5" },
    400: { value: "#f87171" },
    500: { value: "#ef4444" }, // Base
    600: { value: "#dc2626" },
    700: { value: "#b91c1c" },
    800: { value: "#991b1b" },
    900: { value: "#7f1d1d" },
  },
  "pastel-orange": {
    50: { value: "#fffaf5" },
    100: { value: "#fff1e5" },
    200: { value: "#ffd7b8" },
    300: { value: "#ffc590" },
    400: { value: "#ffb066" },
    500: { value: "#ffa24d" },
    600: { value: "#e18740" },
    700: { value: "#bd6c34" },
    800: { value: "#995429" },
    900: { value: "#7a4220" },
  },
  "sunset-orange": {
    50: { value: "#fff7ed" },
    100: { value: "#ffedd5" },
    200: { value: "#fed7aa" },
    300: { value: "#fdba74" },
    400: { value: "#fb923c" },
    500: { value: "#f97316" },
    600: { value: "#ea580c" },
    700: { value: "#c2410c" },
    800: { value: "#9a3412" },
    900: { value: "#7c2d12" },
  },
  tealCustom: {
    50: { value: "#E6FFF9" },
    100: { value: "#C0FFF0" },
    200: { value: "#99FFE6" },
    300: { value: "#73FFDD" },
    400: { value: "#4DFDDA" },
    500: { value: "#64FCD9" },
    600: { value: "#3EEAC3" },
    700: { value: "#2BB39A" },
    800: { value: "#1F7C70" },
    900: { value: "#114E46" },
  },
  indigoCustom: {
    50: { value: "#ECECFF" },
    100: { value: "#D4D5FF" },
    200: { value: "#A9AAFF" },
    300: { value: "#7E80FF" },
    400: { value: "#6265FF" },
    500: { value: "#5B60FD" },
    600: { value: "#494DEE" },
    700: { value: "#3B3FBE" },
    800: { value: "#2C2E8E" },
    900: { value: "#1D1E5F" },
  },
  success: {
    50: { value: "#ECFDF5" },
    100: { value: "#D1FAE5" },
    200: { value: "#A7F3D0" },
    300: { value: "#6EE7B7" },
    400: { value: "#34D399" },
    500: { value: "#10B981" },
    600: { value: "#059669" },
    700: { value: "#047857" },
    800: { value: "#065F46" },
    900: { value: "#064E3B" },
  },
  warning: {
    50: { value: "#FFFBEB" },
    100: { value: "#FEF3C7" },
    200: { value: "#FDE68A" },
    300: { value: "#FCD34D" },
    400: { value: "#FBBF24" },
    500: { value: "#F59E0B" },
    600: { value: "#D97706" },
    700: { value: "#B45309" },
    800: { value: "#92400E" },
    900: { value: "#78350F" },
  },
  error: {
    50: { value: "#FEF2F2" },
    100: { value: "#FEE2E2" },
    200: { value: "#FECACA" },
    300: { value: "#FCA5A5" },
    400: { value: "#F87171" },
    500: { value: "#EF4444" },
    600: { value: "#DC2626" },
    700: { value: "#B91C1C" },
    800: { value: "#991B1B" },
    900: { value: "#7F1D1D" },
  },
};

// theme/semantic-tokens.ts
export const semanticTokens = {
  colors: {
    // Backgrounds
    "bg.canvas": {
      default: "neutral.50",
      _dark: "neutral.900",
    },
    "bg.surface": {
      default: "white",
      _dark: "neutral.800",
    },
    "bg.subtle": {
      default: "primary.50",
      _dark: "primary.900",
    },
    "bg.brand": {
      default: "primary.50",
      _dark: "primary.900",
    },

    // Text
    "fg.default": {
      default: "neutral.900",
      _dark: "neutral.50",
    },
    "fg.muted": {
      default: "neutral.600",
      _dark: "neutral.400",
    },
    "fg.brand": {
      default: "primary.700",
      _dark: "primary.200",
    },

    // Border
    "border.subtle": {
      default: "neutral.200",
      _dark: "neutral.700",
    },
    "border.brand": {
      default: "primary.300",
      _dark: "primary.600",
    },

    // Actions
    "action.primary": {
      default: "primary.500",
      _hover: "primary.600",
      _active: "primary.700",
    },
  },
};

export const semanticColors = {
  colors: {
    primary: {
      solid: {
        value: {
          base: "{colors.primary.600}",
          _dark: "{colors.primary.400}",
        },
      },
      contrast: {
        value: {
          base: "{colors.primary.50}",
          _dark: "{colors.neutral.50}",
        },
      },
      constrastDark: {
        value: {
          base: "{colors.neutral.700}",
          _dark: "{colors.neutral.900}",
        },
      },
      fg: {
        value: {
          base: "{colors.primary.700}",
          _dark: "{colors.primary.200}",
        },
      },
      muted: {
        value: {
          base: "{colors.primary.50}",
          _dark: "{colors.primary.900}",
        },
      },
      subtle: {
        value: {
          base: "{colors.primary.100}",
          _dark: "{colors.primary.800}",
        },
      },
      emphasized: {
        value: {
          base: "{colors.neutral.900}",
          _dark: "{colors.neutral.300}",
        },
      },
      focusRing: {
        value: {
          base: "{colors.primary.500}",
          _dark: "{colors.primary.400}",
        },
      },
    },

    secondary: {
      solid: {
        value: {
          base: "{colors.secondary.500}",
          _dark: "{colors.secondary.400}",
        },
      },
      contrast: {
        value: { base: "{colors.neutral.50}", _dark: "{colors.neutral.900}" },
      },
      fg: {
        value: {
          base: "{colors.secondary.700}",
          _dark: "{colors.secondary.200}",
        },
      },
      muted: {
        value: {
          base: "{colors.secondary.50}",
          _dark: "{colors.secondary.900}",
        },
      },
      subtle: {
        value: {
          base: "{colors.secondary.100}",
          _dark: "{colors.secondary.800}",
        },
      },
      emphasized: {
        value: {
          base: "{colors.secondary.600}",
          _dark: "{colors.secondary.300}",
        },
      },
      focusRing: {
        value: {
          base: "{colors.secondary.500}",
          _dark: "{colors.secondary.400}",
        },
      },
    },

    neutral: {
      solid: {
        value: {
          base: "{colors.neutral.900}", // deep neutral for solid elements
          _dark: "{colors.neutral.600}", // slightly lighter for dark mode
        },
      },
      contrast: {
        value: {
          base: "{colors.neutral.50}", // ensures strong contrast text/icons on dark bg
          _dark: "{colors.neutral.900}", // reverses for dark mode
        },
      },
      fg: {
        value: {
          base: "{colors.neutral.800}", // text/icons on light backgrounds
          _dark: "{colors.neutral.200}", // text/icons on dark backgrounds
        },
      },
      muted: {
        value: {
          base: "{colors.neutral.100}", // soft backgrounds for hover or muted areas
          _dark: "{colors.neutral.800}",
        },
      },
      subtle: {
        value: {
          base: "{colors.neutral.200}", // slightly stronger than muted
          _dark: "{colors.neutral.700}",
        },
      },
      emphasized: {
        value: {
          base: "{colors.neutral.700}", // medium gray for borders or highlights
          _dark: "{colors.neutral.400}", // lighter accent for dark mode
        },
      },
      focusRing: {
        value: {
          base: "{colors.neutral.600}", // visible focus border but not harsh
          _dark: "{colors.neutral.400}",
        },
      },
    },

    red: {
      solid: {
        value: { base: "{colors.red.500}", _dark: "{colors.red.400}" },
      },
      contrast: {
        value: { base: "{colors.neutral.50}", _dark: "{colors.neutral.900}" },
      },
      fg: {
        value: { base: "{colors.red.700}", _dark: "{colors.red.200}" },
      },
      muted: {
        value: { base: "{colors.red.50}", _dark: "{colors.red.900}" },
      },
      subtle: {
        value: { base: "{colors.red.100}", _dark: "{colors.red.800}" },
      },
      emphasized: {
        value: { base: "{colors.red.600}", _dark: "{colors.red.300}" },
      },
      focusRing: {
        value: { base: "{colors.red.500}", _dark: "{colors.red.400}" },
      },
    },

    terracotta: {
      solid: {
        value: {
          base: "{colors.terracotta.500}",
          _dark: "{colors.terracotta.400}",
        },
      },
      contrast: {
        value: { base: "{colors.neutral.50}", _dark: "{colors.neutral.900}" },
      },
      fg: {
        value: {
          base: "{colors.terracotta.700}",
          _dark: "{colors.terracotta.200}",
        },
      },
      muted: {
        value: {
          base: "{colors.terracotta.50}",
          _dark: "{colors.terracotta.900}",
        },
      },
      subtle: {
        value: {
          base: "{colors.terracotta.100}",
          _dark: "{colors.terracotta.800}",
        },
      },
      emphasized: {
        value: {
          base: "{colors.terracotta.600}",
          _dark: "{colors.terracotta.300}",
        },
      },
      focusRing: {
        value: {
          base: "{colors.terracotta.500}",
          _dark: "{colors.terracotta.400}",
        },
      },
    },

    "pastel-orange": {
      solid: {
        value: {
          base: "{colors.pastel-orange.500}",
          _dark: "{colors.pastel-orange.400}",
        },
      },
      contrast: {
        value: { base: "{colors.neutral.50}", _dark: "{colors.neutral.900}" },
      },
      fg: {
        value: {
          base: "{colors.pastel-orange.700}",
          _dark: "{colors.pastel-orange.200}",
        },
      },
      muted: {
        value: {
          base: "{colors.pastel-orange.50}",
          _dark: "{colors.pastel-orange.900}",
        },
      },
      subtle: {
        value: {
          base: "{colors.pastel-orange.100}",
          _dark: "{colors.pastel-orange.800}",
        },
      },
      emphasized: {
        value: {
          base: "{colors.pastel-orange.600}",
          _dark: "{colors.pastel-orange.300}",
        },
      },
      focusRing: {
        value: {
          base: "{colors.pastel-orange.500}",
          _dark: "{colors.pastel-orange.400}",
        },
      },
    },

    dark: {
      solid: {
        value: {
          base: "{colors.dark.700}", // main fill color for dark elements in light mode
          _dark: "{colors.dark.400}", // slightly lighter for dark mode
        },
      },
      contrast: {
        value: {
          base: "{colors.neutral.50}", // ensures text/icons on dark bg remain legible
          _dark: "{colors.neutral.900}",
        },
      },
      fg: {
        value: {
          base: "{colors.dark.800}", // used for text/icons in contexts where bg is light
          _dark: "{colors.dark.100}",
        },
      },
      muted: {
        value: {
          base: "{colors.dark.50}", // subtle hover backgrounds or muted surfaces
          _dark: "{colors.dark.900}",
        },
      },
      subtle: {
        value: {
          base: "{colors.dark.100}", // used for hover or focus surfaces on light mode
          _dark: "{colors.dark.800}",
        },
      },
      emphasized: {
        value: {
          base: "{colors.dark.500}", // stronger hover or border color
          _dark: "{colors.dark.300}",
        },
      },
      focusRing: {
        value: {
          base: "{colors.dark.600}", // accent ring for focus
          _dark: "{colors.dark.400}",
        },
      },
    },

    indigoCustom: {
      solid: {
        value: {
          base: "{colors.indigoCustom.500}", // main fill color for dark elements in light mode
          _dark: "{colors.indigoCustom.400}", // slightly lighter for dark mode
        },
      },
      contrast: {
        value: {
          base: "{colors.indigoCustom.50}", // ensures text/icons on dark bg remain legible
          _dark: "{colors.indigoCustom.900}",
        },
      },
      fg: {
        value: {
          base: "{colors.indigoCustom.800}", // used for text/icons in contexts where bg is light
          _dark: "{colors.indigoCustom.100}",
        },
      },
      muted: {
        value: {
          base: "{colors.indigoCustom.50}", // subtle hover backgrounds or muted surfaces
          _dark: "{colors.indigoCustom.900}",
        },
      },
      subtle: {
        value: {
          base: "{colors.indigoCustom.100}", // used for hover or focus surfaces on light mode
          _dark: "{colors.indigoCustom.800}",
        },
      },
      emphasized: {
        value: {
          base: "{colors.indigoCustom.400}", // stronger hover or border color
          _dark: "{colors.indigoCustom.300}",
        },
      },
      focusRing: {
        value: {
          base: "{colors.indigoCustom.600}", // accent ring for focus
          _dark: "{colors.indigoCustom.400}",
        },
      },
    },

    tealCustom: {
      solid: {
        value: {
          base: "{colors.tealCustom.500}", // main fill color for dark elements in light mode
          _dark: "{colors.tealCustom.400}", // slightly lighter for dark mode
        },
      },
      contrast: {
        value: {
          base: "{colors.tealCustom.900}", // ensures text/icons on dark bg remain legible
          _dark: "{colors.tealCustom.900}",
        },
      },
      fg: {
        value: {
          base: "{colors.tealCustom.800}", // used for text/icons in contexts where bg is light
          _dark: "{colors.tealCustom.100}",
        },
      },
      muted: {
        value: {
          base: "{colors.tealCustom.800}", // subtle hover backgrounds or muted surfaces
          _dark: "{colors.tealCustom.900}",
        },
      },
      subtle: {
        value: {
          base: "{colors.tealCustom.100}", // used for hover or focus surfaces on light mode
          _dark: "{colors.tealCustom.800}",
        },
      },
      emphasized: {
        value: {
          base: "{colors.tealCustom.400}", // stronger hover or border color
          _dark: "{colors.tealCustom.300}",
        },
      },
      focusRing: {
        value: {
          base: "{colors.tealCustom.600}", // accent ring for focus
          _dark: "{colors.tealCustom.400}",
        },
      },
    },

    success: {
      solid: {
        value: { base: "{colors.success.600}", _dark: "{colors.success.500}" },
      },
      contrast: {
        value: { base: "{colors.neutral.50}", _dark: "{colors.neutral.900}" },
      },
      fg: {
        value: { base: "{colors.success.700}", _dark: "{colors.success.200}" },
      },
      muted: {
        value: { base: "{colors.success.50}", _dark: "{colors.success.900}" },
      },
      subtle: {
        value: { base: "{colors.success.100}", _dark: "{colors.success.800}" },
      },
      emphasized: {
        value: { base: "{colors.success.600}", _dark: "{colors.success.300}" },
      },
      focusRing: {
        value: { base: "{colors.success.500}", _dark: "{colors.success.400}" },
      },
    },
    warning: {
      solid: {
        value: { base: "{colors.warning.500}", _dark: "{colors.warning.400}" },
      },
      contrast: {
        value: { base: "{colors.neutral.50}", _dark: "{colors.neutral.900}" },
      },
      fg: {
        value: { base: "{colors.warning.700}", _dark: "{colors.warning.200}" },
      },
      muted: {
        value: { base: "{colors.warning.50}", _dark: "{colors.warning.900}" },
      },
      subtle: {
        value: { base: "{colors.warning.100}", _dark: "{colors.warning.800}" },
      },
      emphasized: {
        value: { base: "{colors.warning.600}", _dark: "{colors.warning.300}" },
      },
      focusRing: {
        value: { base: "{colors.warning.500}", _dark: "{colors.warning.400}" },
      },
    },
    error: {
      solid: {
        value: { base: "{colors.error.600}", _dark: "{colors.error.400}" },
      },
      contrast: {
        value: { base: "{colors.neutral.50}", _dark: "{colors.neutral.900}" },
      },
      fg: {
        value: { base: "{colors.error.700}", _dark: "{colors.error.200}" },
      },
      muted: {
        value: { base: "{colors.error.50}", _dark: "{colors.error.900}" },
      },
      subtle: {
        value: { base: "{colors.error.100}", _dark: "{colors.error.800}" },
      },
      emphasized: {
        value: { base: "{colors.error.600}", _dark: "{colors.error.300}" },
      },
      focusRing: {
        value: { base: "{colors.error.500}", _dark: "{colors.error.400}" },
      },
    },
  },
};
